import { createFileRoute } from "@tanstack/react-router";
import { KontorPage, kontorHead } from "@/pages/KontorPage";

export const Route = createFileRoute("/en/industries/offices-headquarters")({
  head: () => kontorHead("en"),
  component: () => <KontorPage locale="en" />,
});
